import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Main } from "../pages/Principal/main";
import { configs } from "../shared/configs";
import { Login } from "../pages/Login";

export const AppRoutes = () => (
  <BrowserRouter basename={configs.BASENAME}>
    <Routes>
      <Route
          path={configs.ROTA_INICIO}
          element={<Main />}
      />

      <Route 
          path={configs.ROTA_LOGIN}
          element={<Login/>}
      />

      <Route 
          path="*"
          element={<Navigate to={configs.ROTA_INICIO}/>}
      />
    </Routes>
  </BrowserRouter>
);
